import React, { Component, Fragment } from 'react'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn
} from 'material-ui/Table'
import Undo from 'material-ui/svg-icons/content/undo'
import CircularProgress from '@material-ui/core/CircularProgress'
import ActionDelete from 'material-ui/svg-icons/action/delete'
import IconButton from '@material-ui/core/IconButton'
import ImageEdit from 'material-ui/svg-icons/image/edit'
import { withStyles } from '@material-ui/core/styles'
import Paper from '@material-ui/core/Paper'
import { connect } from 'react-redux'
import { laboratoriesActions, confirmActions, messageActions } from '../../actions'
import TablePagination from '@material-ui/core/TablePagination'
import Typography from '@material-ui/core/Typography'
import { listTableStyle } from '../../styles'
import TableSortLabel from '@material-ui/core/TableSortLabel'
import { reloadTable } from '../../utils/reloadTable'
import { findPermission, readOnly } from '../../utils/permissions'
import Visibility from '@material-ui/icons/Visibility'

class ListTable extends Component {
  state = {
    debounce: undefined
  }

  componentWillUpdate(newProps) {
    const { pagination, order, fetchLaboratories, term } = newProps
    const { page, rowsPerPage: perPage } = pagination

    if (reloadTable(newProps, this.props)) {
      const debounce = setTimeout(() => {
        fetchLaboratories({ page, perPage, order, term })
      }, 700)

      this.setState(state => {
        clearTimeout(state.debounce)
        return { debounce }
      })
    }

    return true
  }

  componentDidMount() {
    const { fetchLaboratories } = this.props
    fetchLaboratories()
  }

  handleChangePage = (event, page) => {
    const { pagination, handleChangePage, fetchLaboratories, term } = this.props
    handleChangePage(page)
  }

  handleChangeRowsPerPage = event => {
    const perPage = event.target.value
    const { pagination, fetchLaboratories, handleChangePerPage, term } = this.props
    handleChangePerPage(perPage)
  }

  handleSortTable = column => {
    const { order, changeOrderColumn, changeOrderDirection } = this.props
    if (column === ((order || {}).column || '')) {
      const direction = ((order || {}).direction || 1) === -1 ? 1 : -1
      changeOrderDirection(direction)
    } else {
      changeOrderColumn(column)
    }
  }

  renderActions = laboratory => {
    const { fetchLaboratory, deleteLaboratory, addConfirm, token, restoreLaboratory } = this.props

    return (
      <Fragment>
        {readOnly('laboratorios', token) &&
          !laboratory.deletedAt && (
            <IconButton
              onClick={() => {
                fetchLaboratory(laboratory._id)
              }}
            >
              <Visibility nativeColor={'rgba(0, 0, 0, 0.87)'} />
            </IconButton>
          )}

        {!!laboratory.deletedAt && findPermission('laboratorios', token).remover ? (
          <IconButton
            onClick={() => {
              const { changeMessage } = this.props

              addConfirm({
                confirmMessage: 'Confirma a restauração deste laboratório?',
                confirmFunction: () => {
                  restoreLaboratory(laboratory._id)
                  changeMessage({ message: 'Restauração realizada com sucesso.' })
                }
              })
            }}
          >
            <Undo />
          </IconButton>
        ) : (
          <Fragment>
            {findPermission('laboratorios', token).editar && (
              <IconButton
                onClick={() => {
                  fetchLaboratory(laboratory._id)
                }}
              >
                <ImageEdit />
              </IconButton>
            )}

            {findPermission('laboratorios', token).remover && (
              <IconButton
                onClick={() => {
                  const { changeMessage } = this.props

                  addConfirm({
                    confirmMessage: 'Confirma a exclusão deste laboratório?',
                    confirmFunction: () => {
                      deleteLaboratory(laboratory._id)
                      changeMessage({ message: 'Exclusão realizada com sucesso.' })
                    }
                  })
                }}
              >
                <ActionDelete />
              </IconButton>
            )}
          </Fragment>
        )}
      </Fragment>
    )
  }

  render() {
    const { classes, laboratories = [], loadingLaboratories, pagination, order = {} } = this.props
    return (
      <Paper className={classes.wrapperTable} elevation={4}>
        {!!loadingLaboratories && (
          <div className={classes.wrapperLoader}>
            <CircularProgress />
          </div>
        )}
        <Table
          fixedHeader={true}
          wrapperStyle={{
            display: 'flex',
            flexDirection: 'column',
            maxHeight: 'var(--crud-table-height)'
          }}
          width={'990px'}
        >
          <TableHeader
            displaySelectAll={false}
            className={classes.tableHeader}
            adjustForCheckbox={false}
          >
            <TableRow>
              <TableHeaderColumn>
                <TableSortLabel
                  active={((order || {}).column || '') === 'nome'}
                  direction={((order || {}).direction || 1) === 1 ? 'asc' : 'desc'}
                  onClick={() => {
                    this.handleSortTable('nome')
                  }}
                >
                  Laboratório
                </TableSortLabel>
              </TableHeaderColumn>

              <TableHeaderColumn>CNPJ</TableHeaderColumn>
              <TableHeaderColumn style={{ width: '100px' }}>Ações</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody displayRowCheckbox={false}>
            {(laboratories || []).length ? (
              (laboratories || []).map(laboratory => {
                return (
                  <TableRow key={laboratory._id}>
                    <TableRowColumn>{laboratory.nome}</TableRowColumn>
                    <TableRowColumn>{laboratory.cnpj}</TableRowColumn>
                    <TableRowColumn style={{ width: '100px' }}>
                      {this.renderActions(laboratory)}
                    </TableRowColumn>
                  </TableRow>
                )
              })
            ) : (
              <TableRow>
                <TableRowColumn>
                  <Typography noWrap style={{ textAlign: 'center', padding: '16px' }}>
                    {!!loadingLaboratories ? 'Carregando...' : 'Não há registros.'}
                  </Typography>
                </TableRowColumn>
              </TableRow>
            )}
          </TableBody>
        </Table>
        <div className={classes.paginationWrapper}>
          <div className={classes.page}>Página: {pagination.page + 1}</div>
          <TablePagination
            component="div"
            className={classes.pagination}
            labelRowsPerPage="Itens por página"
            labelDisplayedRows={({ from, to, count, page }) => {
              return `Exibindo de ${from} a ${to} de ${count}`
            }}
            rowsPerPageOptions={[25, 50, 100]}
            count={pagination.length}
            rowsPerPage={pagination.rowsPerPage}
            page={pagination.page}
            backIconButtonProps={{
              'aria-label': 'Página anterior'
            }}
            nextIconButtonProps={{
              'aria-label': 'Próxima página'
            }}
            onChangePage={this.handleChangePage}
            onChangeRowsPerPage={this.handleChangeRowsPerPage}
          />
        </div>
      </Paper>
    )
  }
}

const mapStateToProps = state => {
  return {
    laboratory: state.laboratories.laboratory,
    laboratories: state.laboratories.laboratories,
    loadingLaboratories: state.laboratories.loadingLaboratories,
    token: state.auth.token,
    pagination: state.laboratories.laboratoriesPagination,
    order: state.laboratories.order,
    term: state.searchTable.term
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(laboratoriesActions.openModal())
    },
    closeModal: () => {
      dispatch(laboratoriesActions.closeModal())
    },
    fetchLaboratory: id => {
      dispatch(laboratoriesActions.fetchLaboratory(id))
    },
    fetchLaboratories: options => {
      dispatch(laboratoriesActions.fetchLaboratories(options))
    },
    deleteLaboratory: id => {
      dispatch(laboratoriesActions.deleteLaboratory(id))
    },
    addConfirm: ({ confirmMessage, confirmFunction }) => {
      dispatch(confirmActions.addFunction({ confirmMessage, confirmFunction }))
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    },
    handleChangePage: page => {
      dispatch(laboratoriesActions.handleChangePage(page))
    },
    handleChangePerPage: perPage => {
      dispatch(laboratoriesActions.handleChangePerPage(perPage))
    },
    restoreLaboratory: id => {
      dispatch(laboratoriesActions.restoreLaboratory(id))
    },
    changeOrderColumn: column => {
      dispatch(laboratoriesActions.changeOrderColumn(column))
    },
    changeOrderDirection: direction => {
      dispatch(laboratoriesActions.changeOrderDirection(direction))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withStyles(listTableStyle)(ListTable))



// WEBPACK FOOTER //
// ./src/containers/Laboratories/ListTable.js